import { FC, PropsWithChildren } from 'react'
import { videoMapResponseType } from '../../types/apiResponse/liveTypes'

export const LiveGrid: FC<PropsWithChildren<videoMapResponseType>> = ({
  latestGridKey,
  children,
}) => {
  // Determine the grid columns based on user settings, but override for mobile
  const getGridColumns = () => {
    // Always use single column on mobile regardless of user settings
    const mobileClass = 'grid-cols-1'

    // Desktop classes based on user settings
    const desktopClass = latestGridKey.col === 1
      ? 'md:grid-cols-1 w-full max-w-[1200px] min-w-[400px]'
      : latestGridKey.col === 2
        ? 'md:grid-cols-2'
        : latestGridKey.col === 3
          ? 'md:grid-cols-3'
          : 'md:grid-cols-4'

    return `${mobileClass} ${desktopClass}`
  }

  return (
    <div
      className={`grid grid-flow-auto gap-0 mb-1 content-center justify-center items-center border-1 mx-auto ${getGridColumns()}`}
    >
      {children}
    </div>
  )
}
